import { History, HistoryMap, HistoryEntry, Parents } from 'types';
import StorageManager, { StorageKey } from 'managers/storage.manager';
import { fromArrayToObject, createParentsKey } from 'helpers/history';

class HistoryManager {
  private _history: History = [];
  private _historyMap: HistoryMap = {};

  constructor() {
    const initialHistory = StorageManager.load(StorageKey.PROGRESS) || [];
    this._history = initialHistory;
    this._historyMap = fromArrayToObject(initialHistory);
  }

  public set(history: History) {
    this._history = history;
    this._historyMap = fromArrayToObject(history);
  }
  public addNewParents([father, mother]: Parents) {
    this.addEntry({
      father,
      mother,
      timestamp: Date.now(),
    });
  }
  public addEntry(entry: HistoryEntry) {
    this._history.push(entry);
    const key = createParentsKey([entry.father, entry.mother]);
    this._historyMap[key] = entry.timestamp;
  }
  public reset() {
    this._history = [];
    this._historyMap = {};
  }
  public removeBeforeTimestamp(before: number) {
    const newHistory = this._history.filter(({ timestamp }) => timestamp >= before);
    if (newHistory.length !== this._history.length) {
      this._historyMap = fromArrayToObject(newHistory);
    }

    this._history = newHistory;
  }

  get history() {
    return this._history;
  }
  get historyMap() {
    return this._historyMap;
  }
}

const manager = new HistoryManager();
if (__DEV__) {
  window.__HISTORY = manager;
}
export default manager;
